 import React, { useContext, useEffect, useState } from "react";
import "./Announcements.css";
import { LanguageContext } from "../../context/LanguageContext";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const AnnouncementCard = ({ id, date, title, description, language, publishDate }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/announcements/${id}--${publishDate}`);

  };

  return (
    <div className="card">
      <p className="card-date">{date}</p>
      <h3 className="card-title">{title}</h3>
      <p className="card-description">{description}</p>
      <button className="card-button" onClick={handleClick}>
        {language === "ar" ? "قراءة المزيد" : "Read more"}
      </button>
    </div>
  );
};

const AnnouncementsPage = () => {
  const { language } = useContext(LanguageContext);
  const [announcements, setAnnouncements] = useState([]);
  const [isLoading, setIsLoading] = useState(true);


  useEffect(() => {
    const loadData = async () => {
      try {
         setIsLoading(true); 
        // Fetch announcements from the Google Apps Script endpoint
           const response = await fetch(
          'https://script.google.com/macros/s/AKfycbzOo7F3e0SIcLMVdk3YKYMeLfciW5VlLUGJuESNiAux4MSqO9hITcl8I3MlQtN7E1o05Q/exec'
        );
        const data = await response.json();

        const now = new Date();
        const visible = data.filter((item) => {
          const publish = new Date(item.publishDate);
          const unpublish = new Date(item.unpublishDate);
          return now >= publish && now <= unpublish;
        });

        setAnnouncements(visible);
      } catch (error) {
        console.error("Error loading announcements:", error);
      }
      finally {
      setIsLoading(false);
    }
    };

    loadData();
  }, [language]);

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={language}
        className="announcements-container"
        dir={language === "ar" ? "rtl" : "ltr"}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.5, ease: "easeInOut" }}
      >
          {isLoading ? (
        <p className="loading-message">
          {language === "ar" ? "جاري التحميل..." : "Loading..."}
        </p>
      
    ) : (
        <>
          <h2 className="announcements-title">
            <span className="title-highlight">
              {language === "ar" ? "إعلانات" : "Announcements"}
            </span>
          </h2>
          
          {announcements.length === 0 ? (
            <div className="no-announcements">
                <div className="no-icon">
                 <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#777" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                 <path d="M4 4h16v6H4z" />
                 <path d="M4 14h4l2 3h4l2-3h4" />
                 </svg>
                   </div>

               <p style={{ fontSize: "1.2rem", color: "#777" }}>
                {language === "ar" ? "لا توجد إعلانات حالياً" : "No announcements at the moment"}
               </p>
                </div>
                ) : (
                <div className="cards-grid">
               {announcements.map((item, index) => {
  const title = language === "ar" ? item.title_ar : item.title_en;
  const description = language === "ar" ? item.description_ar : item.description_en;

  return (
    <div style={{ "--card-index": index }} key={item.id}>
      <AnnouncementCard
        id={item.id}
        date={new Date(item.publishDate).toLocaleDateString(language === "ar" ? "ar-EG" : "en-US", {
          year: "numeric",
          month: "long",
          day: "numeric"
        })}
        title={title}
        description={description}
        language={language}
        publishDate={item.publishDate}
      />
    </div>
  );
})}

               </div>
             )}
        </>
      )}
      </motion.div>
    
    </AnimatePresence>
  );
};

export default AnnouncementsPage; 